<template v-if="this.user.loggedIn">
  <div class="container">
    <h1 class="text-center mb-3">Eingestellt Archiv</h1>
    <div v-if="message.success !== undefined">
      <div class="alert alert-success fixed-top text-center" role="alert">
        {{ message.success }}
      </div>
    </div>
    <div v-if="message.error !== undefined">
      <div class="alert alert-danger fixed-top text-center" role="alert">
        {{ message.error }}
      </div>
    </div>
    <div class="card">
      <div
        v-if="!dataArray"
        class="d-flex justify-content-center p-3"
        style="width: 100%"
      >
        <b-spinner label="Spinning"></b-spinner>
      </div>
      <div v-else>
        <div>
          <label for="searchInput" class="d-none">Suchen:</label>
          <b-form-input
            type="text"
            id="searchInput"
            placeholder="Suche..."
            v-model="searchQuery"
          ></b-form-input>
        </div>
        <table class="table table-hover m-0">
          <thead>
            <tr>
              <th>Name</th>
              <th>Stelle</th>
              <th>Abteilung</th>
              <th>Eingegangen</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr @click="createNew(item?.id)" v-for="(item, index) in filteredApplications" :key="index">
              <td>
                <span v-if="item?.firstname">{{
                  item?.firstname + " " + item?.name
                }}</span>
                <span v-else>{{ item?.email }}</span>
              </td>
              <td>{{ item?.jobOfferName }}</td>
              <td>
                {{ item?.department }}
                <template v-if="item?.trainee"
                  ><br /><b-badge>Ausbildung</b-badge></template
                >
              </td>
              <td>{{ convert(item.incoming.toDate()) }}</td>
              <td>
                <div
                  v-if="
                    item?.reply &&
                    (!item?.emails ||
                      !item?.emails.some((email) => email?.read === false))
                  "
                >
                  <font-awesome-icon :icon="['fas', 'reply']" />
                </div>
                <div
                  v-else-if="
                    item?.emails &&
                    item?.emails.some((email) => email?.read === false)
                  "
                >
                  <span class="badge badge-pill badge-danger">{{
                    item?.emails.filter((email) => email?.read === false).length
                  }}</span>
                </div>
                <div v-else>
                  <span class="badge badge-pill badge-danger">NEW</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <b-modal
      size="xl"
      tabindex="-1"
      role="dialog"
      v-model="formularModal"
      :title="jobOfferName"
      aria-hidden="true"
      hide-footer
    >
      <div
        v-if="personData == '' || personData == undefined"
        class="d-flex justify-content-center p-3"
        style="width: 100%"
      >
        <b-spinner label="Spinning"></b-spinner>
      </div>
      <div
        v-if="personData !== '' && personData !== undefined"
        class=""
        style="width: 100%"
      >
        <div id="printMe">
          <b-form-group label="Stelle auswählen" v-if="!jobOfferName">
            <b-form-select
              v-if="jobOptions.length > 0"
              v-model="selectedJobId"
              :options="jobOptions"
              text-field="text"
              value-field="value"
              @change="applyJobData"
              class="mb-3"
            />
          </b-form-group>
          <div>
            <p class="m-0"><b>Name</b></p>
            <div v-if="personData?.privacyPolicy">
              <p>{{ personData?.firstname + " " + personData?.name }}</p>
            </div>
            <div v-else>
              <b-form-input
                v-model="personData.firstname"
                placeholder="Vorname"
                class="mb-1"
              />
              <b-form-input v-model="personData.name" placeholder="Nachname" />
            </div>
            <p v-if="personData?.birthday" class="m-0"><b>Geburtstag</b></p>
            <p>{{ personData?.birthday }}</p>
            <p v-if="personData?.street" class="m-0"><b>Adresse</b></p>
            <p v-if="personData?.street" class="m-0">
              {{ personData?.street }}
            </p>
            <p v-if="personData?.town" class="m-0">
              {{ personData?.zip + " " + personData?.town }}
            </p>
            <p>{{ personData?.country }}</p>
            <p class="m-0"><b>Telefon</b></p>
            <div v-if="personData?.privacyPolicy">
              <p>{{ personData?.phonenumber }}</p>
            </div>
            <div v-else>
              <b-form-input
                v-model="personData.phonenumber"
                placeholder="Telefonnummer eingeben"
              />
            </div>
            <p v-if="personData?.email" class="mt-2"><b>E-Mail</b></p>
            <p>{{ personData?.email }}</p>
          </div>
          <div v-if="personData?.image">
            <ImageBlob :data="{ image: personData?.image }" />
          </div>
          <hr v-if="personData?.coverLetter" />
          <div v-if="personData?.privacyPolicy">
            <p><b>Anschreiben</b></p>
            <div v-html="personData?.coverLetter"></div>
          </div>
          <b-button
            variant="success"
            class="mt-2"
            @click="saveMissingFields()"
            v-if="changed"
            >Speichern</b-button
          >
          <div class="printOnly">
            <hr />
            <p class="m-0"><b>Anlagen</b></p>
            <p v-if="personData?.curriculumVitae" class="m-0">
              <small>Lebenslauf</small>
            </p>
            <div
              v-for="(item, index) in personData?.otherDocuments"
              :key="index"
            >
              <p class="m-0">
                <small>{{ item.name }} </small>
              </p>
            </div>
          </div>
        </div>
        <hr v-if="personData?.curriculumVitae" />
        <p v-if="personData?.curriculumVitae || personData?.otherDocuments">
          <b>Datein</b>
        </p>
        <ButtonBlob
          :data="{ data: personData?.curriculumVitae }"
          v-if="personData?.curriculumVitae"
        />
        <DropDownButtonBlob
          :data="personData?.otherDocuments"
          v-if="personData?.otherDocuments.length > 0"
        />
        <hr />
        <div>
          <p><b>Aktionen</b></p>
          <b-button variant="danger" @click="deleteApplication(personId)"
            >Löschen</b-button
          >
          <b-button
            variant="outline-secondary"
            @click="removeFromArchive(personId)"
            class="m-1"
            ><font-awesome-icon :icon="['fas', 'box-open']" /> Aus Archiv
            entfernen</b-button
          >
        </div>
      </div>
      <div class="mt-3" v-if="personData">
        <hr />
        <p><b>Notizen</b></p>
        <b-form-textarea
          id="notes-textarea"
          placeholder="Notizen..."
          v-model="personData.notes"
          rows="2"
          max-rows="6"
        ></b-form-textarea>
        <b-button
          variant="outline-success"
          class="mt-2"
          @click="saveNotes()"
          :disabled="!notesChanged || !personData.notes"
          >Speichern</b-button
        >
      </div>
      <div v-if="personData && mergeEmailsAndReplies(personData).length > 0">
        <hr />
        <p><b>Nachrichten</b></p>

        <div
          class="accordion"
          role="tablist"
          v-for="(data, index) in mergeEmailsAndReplies(personData)"
          :key="index"
        >
          <!-- <pre>{{data}}</pre> -->
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button
                block
                v-b-toggle="`collapse-${index}`"
                :variant="
                  data?.message ? 'outline-secondary' : 'outline-primary'
                "
                class="d-flex justify-content-between"
              >
                <div v-if="data?.message">Ausgang</div>
                <div v-else>
                  Eingang
                  <span v-if="data?.read === false"
                    ><span class="badge badge-pill badge-danger">1</span></span
                  >
                </div>
                <div>
                  {{
                    typeof data?.dateString === "string"
                      ? data.dateString
                      : data.date.toLocaleDateString("de-DE")
                  }}
                </div>
                <div></div
              ></b-button>
            </b-card-header>
            <b-collapse
              :id="`collapse-${index}`"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <div>
                  <span v-if="data?.type === 'email'"
                    ><b>Von:</b> {{ data.from.name }}
                    {{ data.from.address }}</span
                  ><br />
                  <span v-if="data?.type === 'email'"
                    ><b>Datum:</b>
                    {{
                      data.date
                        .toLocaleDateString("de-DE", {
                          weekday: "long",
                          day: "numeric",
                          month: "long",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        })
                        .replace(",", " um")
                    }}</span
                  ><br />
                  <span v-if="data?.type === 'email'"
                    ><b>An:</b> {{ data.to[0].emailAddress.address }}</span
                  ><br />
                  <span v-if="data?.type === 'email'"
                    ><b>Betreff:</b> {{ data.subject }}</span
                  ><br />
                </div>

                <b-card-text v-html="data?.message || data.body"></b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ImageBlob from "./ImageBlob";
import ButtonBlob from "./ButtonBlob";
import DropDownButtonBlob from "./DropDownButtonBlob";
import moment from "moment";
import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  orderBy,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { firestore } from "../plugins/firebase";

export default {
  name: "Applications",
  computed: {
    ...mapGetters({
      user: "user",
    }),
    filteredApplications() {
      // Convert object to array and include keys as 'id' property
      const arrayData = Array.isArray(this.dataArray)
        ? this.dataArray
        : Object.entries(this.dataArray || {}).map(([key, value]) => ({
            ...value,
            id: key,
          }));
      if (!this.searchQuery) {
        return arrayData;
      }
      const query = this.searchQuery.toLowerCase();
      return arrayData.filter((app) => {
        const fullName = `${app.firstname} ${app.name}`.toLowerCase();
        const jobOfferName = app.jobOfferName
          ? app.jobOfferName.toLowerCase()
          : "";
        return fullName.includes(query) || jobOfferName.includes(query);
      });
    },
  },
  components: {
    ImageBlob,
    ButtonBlob,
    DropDownButtonBlob,
  },
  watch: {
    personData: {
      handler(newD) {
        // console.log('personData changed', newD.firstname, this.personDataOriginal.firstname);
        if (
          newD.firstname !== this.personDataOriginal.firstname ||
          newD.name !== this.personDataOriginal.name ||
          newD.phonenumber !== this.personDataOriginal.phonenumber
        )
          this.changed = true;
        if (newD.notes !== this.personDataOriginal.notes)
          this.notesChanged = true;
      },
      deep: true,
    },
  },
  data() {
    return {
      mailOfAL: "",
      mailToAl: false,
      changed: false,
      dataArray: undefined,
      message: {
        success: undefined,
        error: undefined,
      },
      messageTextForAl: "",
      formularModal: false,
      answerModal: false,
      personData: undefined,
      personDataOriginal: undefined,
      jobOfferName: undefined,
      date: moment(new Date()).format("DD.MM.YYYY"),
      personId: undefined,
      selected: undefined,
      curriculumVitaeURL: undefined,
      textTamplates: [{ text: "Wähle einen Antworttext...", value: null }],
      absendenButton: false,
      selectedJob: null,
      selectedJobId: null,
      jobOptions: [],
      loading: false,
      statusOptions: [
        { value: null, text: "Status wählen", disabled: true },
        { value: "cancellation", text: "Absage" },
        { value: "checkPossibilities", text: "int. Kapazitäten prüfen" },
        { value: "invitation", text: "Einladung" },
        { value: "checkSuperior", text: "Rücksprache mit VG" },
        { value: "pendingReturnMessage", text: "auf RR warten" },
        { value: "secondChoice", text: "Zweite Wahl" },
        { value: "pendingMessageFK", text: "auf FK warten" },
      ],
      selectedStatus: null,
      searchQuery: "",
      notesChanged: false,
    };
  },
  methods: {
    applyJobData() {
      this.changed = true;
      const selected = this.jobOptions.find(
        (j) => j.value === this.selectedJobId,
      );
      if (selected && selected.full) {
        const job = selected.full;
        this.personData.jobOfferName = job.jobOfferName || "";
        this.personData.department = job.department || "";
        this.personData.workingStart = job.workingStart || "";
        this.personData.workingTime = job.workingTime || "";
        this.personData.type = job.type || "";
        this.personData.limited = job.limited || "";
        this.changed = true;
      }
      this.selectedJob = selected;
    },
    async loadData() {
      this.loadResponses();
      const q = query(
        collection(firestore, "application"),
        orderBy("incoming"),
        where("employedArchive", "==", true),
      );
      const querySnapshot = await getDocs(q);
      const tempData = {};
      querySnapshot.forEach((doc) => {
        tempData[doc.id] = doc.data();
      });

      this.dataArray = tempData;
    },
    async loadResponses() {
      const q = query(collection(firestore, "responseSelection"));
      const querySnapshot = await getDocs(q);
      const templateOptions = querySnapshot.docs.map((doc) => {
        const data = doc.data();
        return {
          text: data.title,
          value: data.text,
        };
      });
      this.textTamplates = [
        { text: "Wähle einen Antworttext...", value: null },
        ...templateOptions,
      ];
    },
    createNew(id) {
      this.personId = id;
      this.personData = this.filteredApplications.find(
        (app) => app.id === this.personId,
      );
      this.selectedStatus = this.personData?.status
        ? this.personData.status
        : null;
      this.personDataOriginal = JSON.parse(
        JSON.stringify(this.dataArray[this.personId]),
      );
      this.formularModal = !this.formularModal;
      this.jobOfferName = this.personData?.jobOfferName;
      this.curriculumVitaeURL = undefined;
    },
    convert(data) {
      var date = new Date(data);
      return moment(date).format("DD.MM.YYYY");
    },
    async loadJobOffers() {
      const q = query(collection(firestore, "jobOffers"));
      const querySnapshot = await getDocs(q);
      this.jobOptions = querySnapshot.docs.map((doc) => {
        const data = doc.data();
        return {
          text: data.jobOfferName,
          value: {
            job: data.jobOfferName,
            department: data.department,
          },
        };
      });
    },
    deleteApplication(id) {
      let index = id;
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(
          `Bist du sicher, dass du die Bewerbung von ${this.dataArray[index].firstname} Löschen möchtest?`,
          {
            title: "Bitte bestätigen",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "Löschen",
            cancelTitle: "Behalten",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          },
        )
        .then((value) => {
          if (value) {
            this.applicationModal = false;
            deleteDoc(doc(firestore, "/application", `${id}`))
              .then(() => {
                setTimeout(this.resetMessage, 3000);
                this.loadData();
                this.message.success = "Die Daten wurden erfolgreich gelöscht.";
                this.formularModal = null;
              })
              .catch((error) => {
                console.log(error);
                this.message.error = "Es ist ein Fehler aufgetreten. " + error;
                setTimeout(this.resetMessage, 3000);
              });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async removeFromPool(id) {
      let index = id;
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(
          `Bist du sicher, dass du die Bewerbung von ${this.dataArray[index].firstname} aus dem Pool entfernen möchtest?`,
          {
            title: "Bitte bestätigen",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "Entfernen",
            cancelTitle: "Abbrechen",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          },
        )
        .then(async (value) => {
          if (value) {
            this.applicationModal = false;
            const applicationRef = doc(firestore, "application", `${id}`);
            try {
              await updateDoc(applicationRef, {
                pool: false,
              });
              setTimeout(this.resetMessage, 3000);
              this.loadData();
              this.message.success =
                "Die Bewerbung wurde erfolgreich aus dem Pool entfernt.";
              this.formularModal = null;
            } catch (error) {
              console.log(error);
              this.message.error = "Es ist ein Fehler aufgetreten. " + error;
              setTimeout(this.resetMessage, 3000);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    resetMessage() {
      this.message.success = undefined;
      this.message.error = undefined;
    },
    mergeEmailsAndReplies(applicationData, options = {}) {
      const { sortOrder = "asc", includeHtmlContent = true } = options;
      const mergedItems = [];
      const emails = applicationData.emails || [];
      const replies = applicationData.replyed || [];

      // 1) Original-Emails
      emails.forEach((email, idx) => {
        const dt = this.convertTimestamp(
          email.sentDateTime || email.createdDateTime,
        );
        mergedItems.push({
          type: "email",
          id: idx,
          date: dt,
          dateString: dt.toLocaleDateString("de-DE"),
          subject: email.subject,
          from: email.from?.emailAddress || email.sender?.emailAddress,
          to: email.toRecipients,
          body: includeHtmlContent ? email.body?.content : email.bodyPreview,
          read: email.read,
        });
      });

      // 2) Replies (geplant oder sofort)
      // mergeEmailsAndReplies(applicationData, options = {})
      replies.forEach((reply, idx) => {
        let dt = null;

        if (
          typeof reply.sendAt === "string" &&
          /^\d{1,2}\.\d{1,2}\.\d{4}$/.test(reply.sendAt)
        ) {
          dt = new Date(reply.sendAt.split(".").reverse().join("-"));
        } else if (reply.sendAt instanceof Date) {
          dt = reply.sendAt;
        } else if (reply.sendAt?.toDate) {
          dt = reply.sendAt.toDate();
        }

        // 🔧 HIER NEU: Fallback auf "date" (dein altes Textdatum)
        if (
          !dt &&
          typeof reply.date === "string" &&
          /^\d{1,2}\.\d{1,2}\.\d{4}$/.test(reply.date)
        ) {
          dt = new Date(reply.date.split(".").reverse().join("-"));
        }

        if (!dt && typeof reply.date === "object") {
          dt = reply.date.toDate();
        }

        if (!dt || isNaN(dt.getTime())) {
          dt = new Date(); // letzter Fallback
        }

        // Für die Anzeige
        const ds = dt.toLocaleDateString("de-DE");

        mergedItems.push({
          type: "reply",
          id: idx,
          date: dt,
          dateString: ds,
          subject: `Re: ${applicationData.jobOfferName || "Bewerbung"}`,
          message: reply.message,
        });
      });

      // 3) Sortierung
      mergedItems.sort((a, b) => {
        return sortOrder === "desc" ? b.date - a.date : a.date - b.date;
      });

      return mergedItems;
    },
    async saveNotes() {
      updateDoc(doc(firestore, "application", this.personId), {
        notes: this.personData.notes,
      })
        .then(() => {
          this.message.success = "Die Notizen wurden erfolgreich gespeichert.";
          this.notesChanged = false;
          setTimeout(this.resetMessage, 3000);
        })
        .catch((error) => {
          this.message.error = "Es ist ein Fehler aufgetreten. " + error;
          setTimeout(this.resetMessage, 3000);
        });
    },
    // Hilfsfunktion um Timestamp-Objekte zu konvertieren
    convertTimestamp(timestamp) {
      if (timestamp && timestamp.seconds) {
        return new Date(timestamp.seconds * 1000);
      }
      return new Date(timestamp);
    },
    removeFromArchive() {
      this.$bvModal
        .msgBoxConfirm(
          `Bist du sicher, dass du die Bewerbung von ${this.personData?.firstname} aus dem Archiv entfernen möchtest?`,
          {
            title: "Bitte bestätigen",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "Entfernen",
            cancelTitle: "Abbrechen",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          },
        )
        .then((value) => {
          if (value) {
            let data = this.personData;
            data.employedArchive = false;

            updateDoc(doc(firestore, "application", this.personId), data)
              .then(() => {
                this.message.success =
                  "Die Bewerbung wurde erfolgreich aus dem Archiv entfernt.";
                this.formularModal = null;
                this.loadData();
                setTimeout(this.resetMessage, 3000);
              })
              .catch((error) => {
                this.message.error = "Es ist ein Fehler aufgetreten: " + error;
                setTimeout(this.resetMessage, 3000);
              });
          }
        });
    },
  },
  mounted() {
    this.loadData();
    this.loadJobOffers();
  },
};
</script>
